export default __webpack_public_path__ + "static/media/profile-icon.e44cc285.svg";